import { Navigate, Outlet } from 'react-router-dom';
import { useIsPlatformAdmin } from '@/providers/AuthProvider';

/** Restrict routes to platform super-admins. */
export function RequirePlatformAdmin() {
  const isPlatformAdmin = useIsPlatformAdmin();

  if (!isPlatformAdmin) {
    return <Navigate to="/forbidden" replace />;
  }

  return <Outlet />;
}
